'use client';

import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import styled from 'styled-components';

import type { SheetDraggableProps } from '../types';
import { useSheetContext } from './context';

const SheetHeader = forwardRef<any, SheetDraggableProps>(
  ({ children, disableDrag = false, showDragHandle = false, style = {}, ...rest }, ref) => {
    const { dragProps } = useSheetContext();

    return (
      <HeaderWrapper {...rest} ref={ref} {...(disableDrag ? {} : dragProps)}>
        {showDragHandle && <div className="bg-grey5 mx-auto my-6 h-1 w-20 rounded-md"></div>}
        {children}
      </HeaderWrapper>
    );
  },
);

const HeaderWrapper = styled(motion.div)`
  width: 100%;
`;

export default SheetHeader;
